import React from 'react';
import { connect } from 'react-redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { ApplicationState } from '../../store';
import { SettingsState } from '../../types/redux/SettingsTypes';
import { toEUR, toCZK } from '../../core/utils';


//component state
interface IStateProps {

}

//component props
interface IOwnProps {
    valueCZK: number
    valueEUR: number
}

//redux state props
interface IReduxStateProps {
    settings: SettingsState
}

interface IReduxDispatchProps {

}

type Props = IOwnProps & IReduxStateProps & IReduxDispatchProps & WithTranslation;

class Price extends React.PureComponent<Props, IStateProps> {

    render() {
        
        if( this.props.settings.lang === 'sk' ){
            return toEUR( this.props.valueEUR);
        }
        return toCZK( this.props.valueCZK);

    }
}

const mapStateToProps = ( state: ApplicationState ): IReduxStateProps => ( {
    settings: state.settingsReducer
} );

const mapDispatchToProps = ( dispatch: Function ): IReduxDispatchProps => ( {

} );

export default connect<IReduxStateProps, IReduxDispatchProps, IOwnProps, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps
)( withTranslation()( Price ) );


